import { doc, getDoc, type Firestore } from "firebase/firestore";
import { db } from "./firebase";
import type { AppConfig, ShiftBlock } from "./types";

const DEFAULT_CONFIG: AppConfig = {
  hourlyRate: 15000,
  shifts: [
    { label: "15:00-22:00", hours: 7.0, days: "weekday" },
    { label: "7:30-12:00", hours: 4.5, days: "weekend" },
    { label: "12:00-16:00", hours: 4.0, days: "weekend" },
    { label: "16:00-22:00", hours: 6.0, days: "weekend" },
  ],
  staffing: {
    "15:00-22:00": { weekday: 3, weekend: 0 },
    "7:30-12:00": { weekday: 0, weekend: 2 },
    "12:00-16:00": { weekday: 0, weekend: 2 },
    "16:00-22:00": { weekday: 0, weekend: 3 },
  },
  companyName: "Khu Vui Chơi Nhà Thỏ",
};

let cache: AppConfig | null = null;
let inflight: Promise<AppConfig> | null = null;

export async function getAppConfig(firestore: Firestore = db): Promise<AppConfig> {
  if (cache) return cache;
  if (inflight) return inflight;

  inflight = (async () => {
    const snap = await getDoc(doc(firestore, "config", "app"));
    cache = snap.exists() ? (snap.data() as AppConfig) : DEFAULT_CONFIG;
    return cache;
  })();

  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

export function findShiftBlock(config: AppConfig, label: string): ShiftBlock | undefined {
  return config.shifts.find((s) => s.label === label);
}
